import { useEffect } from "react";

// Single global IntersectionObserver that toggles `is-visible` on any
// element with the `.alpha-reveal` or `.alpha-reveal-stagger` class as it
// enters the viewport. Keeps individual components free of boilerplate.
export default function RevealProvider() {
  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".alpha-reveal, .alpha-reveal-stagger, .alpha-curtain").forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px 5% 0px", threshold: 0.04 }
    );
    const scan = () => {
      document
        .querySelectorAll(".alpha-reveal:not(.is-visible), .alpha-reveal-stagger:not(.is-visible), .alpha-curtain:not(.is-visible)")
        .forEach((el) => io.observe(el));
    };
    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);
  return null;
}
